
import { useReducer } from 'react';
import { FETCH_ACTION_TYPES, fetchReducer, FetchState } from 'src/reducers/fetchReducer';
import { SettingsPostResponse } from 'src/api/settingAPIPost';
import { updateSettings } from 'src/api/settingAPIPost';
import  SettingTypePost  from 'src/types/SettingTypePost';
import { SearchDetailsState, SEARCH_DETAILS_ACTION_TYPES } from 'src/stateProviders/searchDetailsStateProvider';
import { useSearchDetailsDispatchContext } from 'src/stateProviders/useSearchDetailsStateContext';
import showNotificationError from 'src/components/common/Notification';
import {
 // notification,
  message
} from 'antd';
import { useHistory } from 'react-router-dom';

const initialState: FetchState<SettingTypePost> = {
  loading: false,
  error: false,
  data: null,
};

export type JobNameDispatch = {
  settingsUpdatedsss: (values:any,fromPage:string,form:any, id:any) => void;
};

const useSettingsPostFetch = (): [FetchState<SettingsPostResponse>, JobNameDispatch] => {
  const [state, dispatch] = useReducer(fetchReducer, initialState);
  const dispatchDetailsContext = useSearchDetailsDispatchContext();
  //const getSkinName = localStorage.getItem("_SKIN")
  const history = useHistory();
  return [
    state as FetchState<SettingsPostResponse>,
    {
      settingsUpdatedsss: async (values) => {
        console.log("SearchNameRequest==", values);
        dispatch({ type: FETCH_ACTION_TYPES.loading, payload: { loading: true } });
        try {
          const response: SettingsPostResponse = await updateSettings(values);
          if (response !== undefined && response.success===true) {
            message.loading("Action in progress...", 0.5) ;
            message.success(response.message,2);
              setTimeout(() => {
                const redirectUrl = '/settings/account-settings';
                history.replace(redirectUrl);
              }, 1000);
            dispatchDetailsContext({
              type: SEARCH_DETAILS_ACTION_TYPES.setSettingsPost,
              payload: { settingsUpdated:true } as SearchDetailsState,
            });
          } else {
            message.loading("Action in progress...", 0.5) ;
            showNotificationError(response.message);
           }  
        }          
         catch (e) {
          dispatch({ type: FETCH_ACTION_TYPES.setError, payload: { error: e } });
        }
      },
    },
  ];
};

export default useSettingsPostFetch;


